import { createReducer, on } from "@ngrx/store";
import { IRoundHistoryState } from "./interfaces";
import { addHistoryRounds, clearHistoryRounds } from "./round-history.actions";


export const initialState: IRoundHistoryState = {
    roundCoefficients: []
};

const reducer = createReducer(initialState,
    on(addHistoryRounds, (state: IRoundHistoryState, props: { roundCoefficients: number[] }) => {
        return {
            ...state,
            roundCoefficients: [
                ...props.roundCoefficients,
                ...state.roundCoefficients.slice(0, 29)
            ]
        };
    }),
    on(clearHistoryRounds, (state: IRoundHistoryState) => {
        return {
            ...state,
            roundCoefficients: []
        };
    })
);

export function roundHistoryReducer(state: IRoundHistoryState, action: any) {
    return reducer(state, action);
}
